'use client';

import useFilter from 'hooks/use-filter';
import { CatChip } from 'components/blocks-components';
import { useLoaderOverlay } from 'app/[lang]/[esite]/contexts/loader-overlay-context';
import { decodeString } from '@cat-ecom/common/utils/stringUtils';

export interface FacetChipProps {
  label: string;
  facetId: string;
}

const FacetChip = ({ label, facetId }: FacetChipProps) => {
  const { handleSortByFacet } = useFilter();
  const { startTransition, setSelectedFacets, selectedFacets } =
    useLoaderOverlay();

  const handleItemClick = () => {
    if (typeof selectedFacets === 'string') {
      setSelectedFacets(undefined);
    } else {
      const updatedFacets = selectedFacets.filter(
        (item) => item !== decodeString(facetId)
      );
      setSelectedFacets(updatedFacets);
    }
    startTransition(() => {
      handleSortByFacet(facetId, false);
    });
  };

  return (
    <CatChip
      onBlChipRemove={handleItemClick}
      removable
      size="sm"
      data-testid="facet-chip"
    >
      {label}
    </CatChip>
  );
};

export default FacetChip;
